export default [
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/budget-line-setup/:pageId',
        component: () => import('@/views/page/company/procurement/budget-line-setup/List.vue'),
        name: 'budget-line-setup',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/budget-line-setup-add/:pageId',
        component: () => import('@/views/page/company/procurement/budget-line-setup/Add.vue'),
        name: 'budget-line-setup-add',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/budget-line-setup-edit/:pageId/:budgetLineId',
        component: () => import('@/views/page/company/procurement/budget-line-setup/Add.vue'),
        name: 'budget-line-setup-edit',
        meta: {
            requiresAuth: true
        }
    },
]
